import { Button, Dropdown, Space, Modal, message } from 'antd';
import type { MenuProps } from 'antd';
import { ThunderboltOutlined, SyncOutlined } from '@ant-design/icons';
import { ProductState } from '@erpgold/shared';
import { PRODUCT_STATE_LABEL } from '../parts/constants';

interface BulkToolbarProps {
  count: number;
  loading?: boolean;
  onStateChange: (state: ProductState) => void;
  onClear: () => void;
}

const BULK_STATE_ACTIONS: Array<{ state: ProductState; titleVerb: string }> = [
  { state: ProductState.ACTIVE, titleVerb: 'Hiển thị' },
  { state: ProductState.INACTIVE, titleVerb: 'Ẩn' },
  { state: ProductState.DRAFT, titleVerb: 'Chuyển sang nháp' },
];

export function BulkToolbar({ count, loading, onStateChange, onClear }: BulkToolbarProps) {
  const stateMenuItems: MenuProps['items'] = BULK_STATE_ACTIONS.map(({ state, titleVerb }) => ({
    key: String(state),
    label: PRODUCT_STATE_LABEL[state],
    onClick: () => {
      Modal.confirm({
        title: `${titleVerb} ${count} sản phẩm?`,
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        onOk: () => onStateChange(state),
      });
    },
  }));

  return (
    <div
      style={{
        background: '#fff6f8',
        border: '1px solid #ffccd5',
        borderRadius: 6,
        padding: '8px 16px',
        marginBottom: 12,
      }}
    >
      <Space>
        <span>
          Đã chọn <strong>{count}</strong> sản phẩm
        </span>
        <Dropdown menu={{ items: stateMenuItems }} trigger={['click']}>
          <Button icon={<ThunderboltOutlined />} loading={loading}>
            Thao tác
          </Button>
        </Dropdown>
        <Button
          icon={<SyncOutlined />}
          onClick={() => void message.info('Tính năng đang phát triển')}
        >
          Đồng bộ MISA ({count} SP)
        </Button>
        <Button type="link" onClick={onClear}>
          Bỏ chọn
        </Button>
      </Space>
    </div>
  );
}
